import { render, staticRenderFns } from "./AddNewAccount.vue?vue&type=template&id=561757d2&"
import script from "./AddNewAccount.vue?vue&type=script&lang=js&"
export * from "./AddNewAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561757d2')) {
      api.createRecord('561757d2', component.options)
    } else {
      api.reload('561757d2', component.options)
    }
    module.hot.accept("./AddNewAccount.vue?vue&type=template&id=561757d2&", function () {
      api.rerender('561757d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/ServicesPage/AddNewAccount.vue"
export default component.exports